import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageTitle, type PageTitleConfig, setDocumentTitle } from '../utils/pageTitleUtils';

interface UsePageTitleOptions {
  dynamicData?: Record<string, string>;
  customTitle?: string;
  customDescription?: string;
}

export const usePageTitle = (options: UsePageTitleOptions = {}) => {
  const location = useLocation();
  const { dynamicData, customTitle, customDescription } = options;

  useEffect(() => {
    let titleConfig: PageTitleConfig;

    if (customTitle) {
      titleConfig = {
        title: customTitle,
        description: customDescription,
      };
    } else {
      titleConfig = getPageTitle(location.pathname, dynamicData);
    }

    setDocumentTitle(titleConfig.title, titleConfig.description);
  }, [location.pathname, dynamicData, customTitle, customDescription]);

  return {
    title: customTitle || getPageTitle(location.pathname, dynamicData).title,
    description: customDescription || getPageTitle(location.pathname, dynamicData).description,
  };
};
